const formatDishMenuTitleOriginFieldPrefix = (fieldName, menuTitleId) =>
  `${fieldName}:${menuTitleId}`

export default formatDishMenuTitleOriginFieldPrefix
